import { useEffect, useState } from 'react'

export function useIsVisible(ref: any, rootMargin = '200px', freezeOnceVisible = false) {
	const [isIntersecting, setIntersecting] = useState(false)

	useEffect(() => {
		const el = ref.current
		if (!el) return

		const observer = new IntersectionObserver(
			([entry]) => {
				setIntersecting(entry.isIntersecting)
				if (freezeOnceVisible && entry.isIntersecting) {
					observer.disconnect()
				}
			},
			{ rootMargin }
		)

		observer.observe(el)
		return () => {
			observer.disconnect()
		}
	}, [ref, rootMargin, freezeOnceVisible])

	return isIntersecting
}
